import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TileDropdownMenuFooter',
  setup(__props) {

const PLY_APP_URL = process.env.VUE_APP_APP_URL;

return { __sfc: true,PLY_APP_URL }
}

})